import { createRoot } from 'react-dom/client';

// third party
import { SnackbarProvider } from 'notistack';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// project imports
import App from 'App';

import AuthProvider from 'providers/Auth';
import LiffProvider from 'providers/Liff';
import ToastProvider from 'providers/Toast';
import * as serviceWorker from 'serviceWorker';
import { store } from 'store';

// defaultTheme

// style + assets
import 'assets/scss/style.scss';
import AuthWrapper from 'AuthWrapper';
import configs from 'configs';
import { initAxiosClient } from 'utils/axios';

// ==============================|| REACT DOM RENDER  ||============================== //
initAxiosClient(store);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <Provider store={store}>
        <LiffProvider liffId={configs.liffId} mock={configs.stage === 'development' ? require('./mock').liff : undefined}>
            <AuthProvider>
                <SnackbarProvider maxSnack={3}>
                    <ToastProvider>
                        <BrowserRouter basename={configs.basename}>
                            <AuthWrapper>
                                <App />
                            </AuthWrapper>
                        </BrowserRouter>
                    </ToastProvider>
                </SnackbarProvider>
            </AuthProvider>
        </LiffProvider>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
